import { reactive, provide } from "vue"

import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign"
// import CampaignModel from "@/core/Campaign/model/CampaignModel"
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js"

import Locale from "@/helper/locale/Locale"

export default function useCampaignComposable() {

    const states = reactive({
        /**@type {import("@/core/Campaign/model/CampaignModel").default} */
        campaign: null,
        builder: new CampaignConfigBuilder()
    })

    // set default
    states.builder.setLocale(Locale.getLocaleCode())

    /**
     *
     * @returns {Promise<import("@/core/Campaign/model/CampaignModel").default>}
     */
    const apiGetCampaignDetail = () => {
        // do nothing
        return new Promise((resolve, reject) => {
            BzbsCampaign.apiGetCampaignDetail(states.builder.create()).subscribe({
                next: (data) => {
                    // console.log(data);
                    states.campaign = data
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    provide("campaignStates", states)

    return {
        states,
        apiGetCampaignDetail,
    }
}
